<template>
  <div>
    <div class="partHeader">
      <div class="partHeader1-0">
        <router-link to="/" class="miniImgBig"> <img class="navbarBrand" src="../assets/img/header/mainlogo.svg" /></router-link>
        <router-link to="/" class="miniImg"> <img class="navbarBrand" src="../assets/img/header/mainlogo.svg" /></router-link>
      
      </div>
      <div class="partHeader1-1">
        <ul style="margin-top:38px; margin-bottom:32px">
          <li >
            <ul class="demo">
              <li>
              
                <router-link class="nav-link link" to="about"
                >О КОМПАНИИ</router-link>
              </li>
              <li class="nav-item mr-1 mt-3">
                <router-link class="nav-link link"  to="production"
                >Производство</router-link>
              </li>
              <!-- <li class="nav-item mr-1 mt-3">
                
                <router-link class="link2" style="text-decoration: none;" to="about-company"
                >Направления деятельности</router-link>
              </li> -->
              <li class="nav-item mr-1 mt-3">
               
                <router-link class="nav-link link"  to="partner"
                >Партнеры</router-link>
              </li>
              
            </ul>
          </li>
        </ul>
      </div>

      <div class="partHeader1-2">
        <ul style="margin-top:38px">
          <li class="nav-item">
            <ul class="demo">
              

              <li class="nav-item mr-1 mt-3">
                <router-link class="nav-link link"  to="news"
                >Новости</router-link>
                
              </li>
              <li class="nav-item mr-1 mt-3">
                <router-link class="nav-link link"  to="contact"
                >Контакты</router-link>
              
              </li>
              <li class="nav-item mr-1 mt-3">
                <router-link class="nav-link link"  to="project"
                >проекты</router-link>
              
              </li>
            </ul>
          </li>
        </ul>
      </div>
      

      <div class="partHeader1-3">
        <ul style="margin-top:38px">
          <li class="nav-item">
            <ul class="demo">
              

              
              <li class="nav-item mr-1 mt-3">
                <router-link class="nav-link link"  to=""
                >Портфолио</router-link>
              
              </li>
            </ul>
          </li>
        </ul>
      </div>
      
      <div class="partHeader1-4">
        
        <img @click="openClose()" class="burgerB" style="" src="../assets/menu.svg" alt="" />
      </div>

      <div class="partHeader1-5">
        <div class="phoneInfo" style="margin-top:48px">
          <ul class="demo">
            <li>
              <h5 class="info">(+99897) 108 4444</h5>
              <h5 class="info">(+99897) 109 4444</h5>
              <h6 class="miniinfo ">Пон - Суб: 9:00 - 19:00</h6>
            </li>
            <li class="mt-3">
              <h5 class="info">г.Ташкент, Сергели</h5>
              <h6 class="miniinfo ">ул.Нилуфар 77/7, 100155</h6>
            </li>
          </ul>
        </div>
      </div>

      <div class="partHeader1-5" >
        <div class="langBox">
          <!-- <span class="nlang">UZ</span> -->

          <!-- <span class="nlang lanmargin">RU</span> -->

          <!-- <span class="nlang lanmargin">EN</span> -->
        </div>
      </div>

      <!-- <div class="partHeader1-6"></div> -->
    </div>
    <section class="bigMenu" v-if="isOpen">
      <div class="bigMenuCancelB" @click="openClose()">
        <img
          
          class="cancelImage"
          src="../assets/img/header/cancelIcon.png"
          alt=""
        />
      </div>
      <div class="navbar-all" style="display: flex; justify-content: space-evenly">
        <div class="afteropen">
          <div @click="openClose()">
          <router-link class="link2"  to="about"
                >О КОМПАНИИ</router-link></div>
          
          <div @click="openClose()">
          <router-link class="link2"  to="production"
                >Производство</router-link></div>
          <!-- <ul>
            <li class="link3">Механическая обработка</li>
            <li class="link3">Сборка изделий</li>
            <li class="link3">Упаковка и маркировка</li>
          </ul> -->
          <!-- <h5 class="link2">Услуги</h5>
          <ul class="mb-5">
            <li class="link3">Доставка и монтаж</li>
            <li class="link3">Металлоизделия по чертежам заказчика</li>
          </ul> -->
          <div @click="openClose()">
          <router-link class="link2"  to="project"
                >Проекты</router-link></div>
                <div @click="openClose()">
          <router-link class="link2"  to="partner"
                >партнеры</router-link></div>
                <div @click="openClose()">
          <router-link class="link2" to="news"
                >Новости</router-link></div>
                <div @click="openClose()">
          <router-link class="link2"  to="contact"
                >контакты</router-link></div>
          
        </div>
        <div class="navbar-second-section">
          <h6 class="link2">Направления деятельности</h6>
          <ul>
            <li class="link3" @click="openClose()">
              <router-link class="link3" to="MetalCons"
                >Металлоконструкции</router-link
              >
            </li>

            <li class="link3" @click="openClose()">
              <router-link class="link3" to="Embedded"
                >Закладная деталь</router-link
              >
            </li>
            <li class="link3" @click="openClose()">
              <router-link class="link3" to="Decorative"
                >Декоративные фонарные столбы</router-link
              >
            </li>
            <li class="link3" @click="openClose()">
              <router-link class="link3" to="Fences"
                >Заборы и ворота
              </router-link>
            </li>

            <li class="link3 mb-4" @click="openClose()">
              <router-link class="link3" to="Metaldecorative"
                >Металлические декоративные панели</router-link
              >
            </li>
            <li class="link3" @click="openClose()">
              <router-link class="link3" to="Awnings">Навесы</router-link>
            </li>
            <li class="link3" @click="openClose()">
              <router-link class="link3" to="Balcony"
                >Балконные ограждения</router-link
              >
            </li>

            <li class="link3" @click="openClose()">
              <router-link class="link3" to="Parking"
                >Парковочные барьеры</router-link
              >
            </li>
            <li class="link3" @click="openClose()">
              <router-link class="link3" to="Metalstaircase"
                >Перила для лестницы</router-link
              >
            </li>

            <li class="link3" @click="openClose()">
              <router-link class="link3" to="Bus"
                >Автобусная остановка</router-link
              >
            </li>
            <li class="link3" @click="openClose()">
              <router-link class="link3" to="Benches">Скамейки</router-link>
            </li>
            <li class="link3" @click="openClose()">
              <router-link class="link3" href="#">Урны для мусора</router-link>
            </li>

            <li class="link3" @click="openClose()">
              <router-link class="link3" to="Equipment"
                >Уличные фитнес тренажёры</router-link
              >
            </li>

            <li class="link3" @click="openClose()">
              <router-link class="link3" to="Playgrounds"
                >Детские площадки</router-link
              >
            </li>
            <li class="link3" @click="openClose()">
              <router-link class="link3" to="Gazebos">Беседки</router-link>
            </li>
            <li class="link3" @click="openClose()">
              <router-link class="link3" to="Pointers">Указатели</router-link>
            </li>
          </ul>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  name: "header-nav",
  data() {
    return {
      show: true,
      isOpen: false,
    };
  },
  methods: {
    openClose() {
      console.log("open close");
      // Toggle between open or closed ( true || false )
      this.isOpen = !this.isOpen;
    },
    toggleNavbar() {
      this.show = !this.show;
    },
  },
};
</script>
<style scoped>
.router-link-active{
  text-decoration: underline;
  color: #36454F;
}

/**************part12 */
.miniImg{
  display: none;
}

.partHeader {
  display: grid;
  grid-template-columns: 150px 1fr 1fr 1fr 1fr 1fr;
  grid-auto-rows: minmax(1136, auto);
  background: #fbfbfb;
}
.partHeader1-0 {
  grid-column: 1/2;
  grid-row: 1/2;
}
.partHeader1-1 {
  grid-column: 2/3;
  grid-row: 1/2;
}
.partHeader1-2 {
  grid-column: 3/4;
  grid-row: 1/2;
}
.partHeader1-3 {
  grid-column: 4/5;
  grid-row: 1/2;
  text-align: center;
}
.partHeader1-4 {
  grid-column: 5/6;
  grid-row: 1/2;
}
.partHeader1-5 {
  grid-column: 6/7;
  grid-row: 1/2;
  padding-right: 5rem;
}


@font-face {
  font-family: "Inter";
  src: url("~@/assets/font/Inter-Regular.ttf");
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: "Inter";
  src: url("~@/assets/font/Inter-SemiBold.ttf");
  font-weight: 600;
  font-style: normal;
}
.link1 {
  width: 256px;
  height: 16px;

  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  /* identical to box height, or 133% */

  display: flex;
  align-items: center;
  letter-spacing: 0.05em;
  text-transform: uppercase;

  color: #92a2ac;
}
.link2 {
  width: 256px;
  height: 16px;
  margin-top:15px;

  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  /* identical to box height, or 133% */
  text-decoration: none;
  display: flex;
  align-items: center;
  letter-spacing: 0.05em;
  text-transform: uppercase;

  /* metalix (ligtt,text) */

  color: #36454f;
}
.link2:active{
  color: blue;
}
.link3 {
  width: 240px;
  height: 16px;
  margin-top: 18px;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  /* identical to box height, or 133% */
  text-decoration: none;
  letter-spacing: 0.1em;

  /* metalix (ligtt,text) */

  color: #36454f;
}

.bigMenu {
  position: absolute !important;
  width: 30vw;
  height: 100vh;
  z-index: 88;
  margin-top: -233px;
  text-align: left;
  background: #f2f6f5;

}
.navbar-second-section{
  margin-left: -7rem;
}
.bigMenuCancelB {
  width: 96px;
  height: 96px;
  background: #ecf2f1;
  margin-left: auto;
  margin-right: 48px;
  cursor: pointer;
  margin-top: 3rem;
}
ul {
  list-style-type: none;
}
.cancelImage {
  margin-top: 40px;
  margin-left: 32px;
}

.burgerB {
  margin-top:48px;
    cursor: pointer;
  /* margin-left: 10rem; */
}
.phoneInfo {
  margin-left: 20rem;
}
.langBox {
margin-top: 48px; margin-left:96px;margin-right: 96px
}
.lanmargin {
  margin-left: 40px;
}
ul.demo {
  list-style-type: none;
  margin: 0;
  padding: 0;
  text-align: left;
}
.afteropen{
  margin-left: 0rem;
}
.nlang {
  height: 16px;

  top: calc(50% - 16px / 2);

  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  /* identical to box height, or 133% */

  text-align: right;
  letter-spacing: 2px;
  text-transform: uppercase;

  /* metalix (ligtt,text) */

  color: #36454f;

  /* Inside Auto Layout */

  flex: none;
  order: 0;
  flex-grow: 0;
  margin: 0px 10px;
}
.navbar {
  background-color: #fbfbfb;
  padding: 0;
}
.navbarBrand {
  padding-top: 40px;
  padding-left: 12px;
  padding-bottom: 40px;
  padding-right: 32px;
}
.rec {
  position: absolute;
  visibility: hidden;
  width: 1px;
  height: 224px;
  left: 1112px;
  top: 0px;

  background: #b4c0cf;
}
.miniinfo {
  width: 290px;
  height: 16px;

  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 10px;
  line-height: 16px;
  /* identical to box height, or 160% */

  text-align: right;
  letter-spacing: 0.15em;
  text-transform: uppercase;

  color: #92a2ac;
}
.info {
  width: 290px;
  height: 16px;

  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  /* identical to box height, or 133% */

  text-align: right;
  letter-spacing: 0.15em;
  text-transform: uppercase;

  /* metalix (ligtt,text) */

  color: #36454f;
}
.link {
  width: 240px;
  height: 24px;

  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  /* identical to box height, or 200% */

  letter-spacing: 2px;
  text-transform: uppercase;

  /* metalix (ligtt,text) */

  color: #36454f;
}

/* Smartphones (portrait and landscape) ----------- */
@media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
  /* Styles */
 .miniImg{
   display: inline;
 }
 .miniImgBig{
   display: none;
 }
 .bigMenu{
   width: 100vw !important;
   padding-top: 8rem !important;
height: 1300px;
 }
 .navbar-second-section {
    margin-left: 0rem;
}
.navbarBrand{
    width: 64px !important;
    height: 64px !important;
    padding: 0 !important;
  }
  .burgerB{
    margin-top: 16px;
   margin-right: 4rem;
  }
  .navbar-all{
    display: block !important;
    margin-left: 3rem;
  }
  .cancelImage{
    margin-top: .5rem !important;
margin-left: 0.5rem !important;
  }
  .partHeader {
    display: grid;
    grid-template-columns: 200px 1fr 1fr !important;
     grid-auto-rows: minmax(1136, auto);
     background: #F5F6F6;
  }
  .bigMenuCancelB{
    width: 50px;
    height: 50px;
    margin-top: 2.5rem;
  }
  .partHeader1-0{
    text-align: left;
    margin-left: 16px;
    
  }
  .partHeader1-1{
    display: none;
  }
  .partHeader1-2{
    display: none;
  }
 
  .partHeader1-3 {
  display: none;
}
.partHeader1-5 {
  display: none;
}
.langBox {
  margin-top: 18px !important;
  margin-left:6px !important;
  margin-right: 6px !important;
}

}

/* Smartphones (landscape) ----------- */
@media only screen and (min-width: 321px) {
  /* Styles */
}

/* Smartphones (portrait) ----------- */
@media only screen and (max-width: 320px) {
  /* Styles */
}

/* iPads (portrait and landscape) ----------- */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  /* Styles */
  .bigMenuCancelB{
    margin-top: 5rem;
    width: 80px;
    height: 80px;
  }
  .cancelImage{
    margin-top: 25px;
    margin-left: 25px;
  }
.partHeader {
  display: grid;
  grid-template-columns: 50px 1fr 1fr !important;
  grid-auto-rows: minmax(1136, auto);
  background: #fbfbfb;
}
.partHeader1-0 {
  grid-column: 1/2;
  grid-row: 1/2;
}
.partHeader1-1 {
display: none !important;
}
.partHeader1-2 {
 display: none;
}
.partHeader1-4 {
  grid-column: 3/6;
  grid-row: 1/2;
  text-align: center;
}
.partHeader1-3{
  display: none;
}
.partHeader1-5 {
  display: none;
}
.bigMenu {
  width: 77vw;}
}

/* iPads (landscape) ----------- */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
  
  .burgerB {
    margin-left: 0rem;
  }
   /*
  .phoneInfo {
    margin-left: 0rem;
  }
  .langBox {
    margin-right: 0px;
    margin-top: 0;
    margin-bottom: auto;
    margin-left: auto;
  }
  .navbarBrand {
    padding-top: 20px;
    padding-left: 2px;
    padding-bottom: 40px;
    padding-right: 2px;
  }

  .lanmargin {
    margin-left: 40px;
  }
  ul.demo {
    list-style-type: none;
    margin: 0;
    padding: 0;
    text-align: left;
  }
  
  .nlang {
    height: 16px;

    top: calc(50% - 16px / 2);

    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    /* identical to box height, or 133% /

    text-align: right;
    letter-spacing: 2px;
    text-transform: uppercase;

    /* metalix (ligtt,text) /

    color: #36454f;

    /* Inside Auto Layout /

    flex: none;
    order: 0;
    flex-grow: 0;
    margin: 0px 10px;
  }
  .navbar {
    background-color: #fbfbfb;
    padding: 0;
  }
  .rec {
    position: absolute;
    visibility: hidden;
    width: 1px;
    height: 224px;
    left: 1112px;
    top: 0px;

    background: #b4c0cf;
  }
  .miniinfo {
    width: 290px;
    height: 16px;

    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 10px;
    line-height: 16px;
    /* identical to box height, or 160% /

    text-align: right;
    letter-spacing: 0.15em;
    text-transform: uppercase;

    color: #92a2ac;
  }
  .info {
    width: 290px;
    height: 16px;

    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    /* identical to box height, or 133% /

    text-align: right;
    letter-spacing: 0.15em;
    text-transform: uppercase;

    /* metalix (ligtt,text) /

    color: #36454f;
  }
  .link {
    width: 110px;
    height: 24px;

    font-family: Inter;
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 24px;
    /* identical to box height, or 200% /

    letter-spacing: 2px;
    text-transform: uppercase;

    /* metalix (ligtt,text) /

    color: #36454f;
  }*/
}

/* iPads (portrait) ----------- */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  /* Styles */
}

/* Desktops and laptops ----------- */
@media only screen and (min-device-width: 1025px) and (max-width: 1224px) {
  /* Styles */

  .burgerB {
    margin-left: 2rem;
  }
  .phoneInfo {
    margin-left: 3rem;
  }
  .langBox {
    margin-right: 20px;
    margin-top: 0;
    margin-bottom: auto;
    margin-left: auto;
  }
  .lanmargin {
    margin-left: 4px;
  }
  ul.demo {
    list-style-type: none;
    margin: 0;
    padding: 0;
    text-align: left;
  }

  .nlang {
    height: 16px;

    top: calc(50% - 16px / 2);

    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    /* identical to box height, or 133% */

    text-align: right;
    letter-spacing: 2px;
    text-transform: uppercase;

    /* metalix (ligtt,text) */

    color: #36454f;

    /* Inside Auto Layout */

    flex: none;
    order: 0;
    flex-grow: 0;
    margin: 0px 10px;
  }
  .navbar {
    background-color: #fbfbfb;
    padding: 0;
  }
  .navbarBrand {
    padding-top: 40px;
    padding-left: 48px;
    padding-bottom: 40px;
    padding-right: 32px;
  }
  .rec {
    position: absolute;
    visibility: hidden;
    width: 1px;
    height: 224px;
    left: 1112px;
    top: 0px;

    background: #b4c0cf;
  }
  .miniinfo {
    width: 290px;
    height: 16px;

    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 10px;
    line-height: 16px;
    /* identical to box height, or 160% */

    text-align: right;
    letter-spacing: 0.15em;
    text-transform: uppercase;

    color: #92a2ac;
  }
  .info {
    width: 290px;
    height: 16px;

    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    /* identical to box height, or 133% */

    text-align: right;
    letter-spacing: 0.15em;
    text-transform: uppercase;

    /* metalix (ligtt,text) */

    color: #36454f;
  }
  .link {
    width: 240px;
    height: 24px;

    font-family: Inter;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 24px;
    /* identical to box height, or 200% */

    letter-spacing: 2px;
    text-transform: uppercase;

    /* metalix (ligtt,text) */

    color: #36454f;
  }
  .bigMenu{
    width: 50vw;
  }
  .navbar-second-section{
    margin-left: -9rem;
  }
}

/* Desktops and laptops  1280----------- */
@media (min-width: 1025px) and (max-width: 1280px) {
  /* Styles */
.burgerB {
    margin-left: 2rem;
  }
.partHeader {
  display: grid;
  grid-template-columns: 120px 1fr 1fr 1fr 1fr 1fr;
  grid-auto-rows: minmax(1136, auto);
  background: #fbfbfb;
}
.partHeader1-0 {
  grid-column: 1/2;
  grid-row: 1/2;
}
.partHeader1-1 {
  grid-column: 2/3;
  grid-row: 1/2;
}
.partHeader1-2 {
  grid-column: 3/4;
  grid-row: 1/2;
}
.partHeader1-3 {
  grid-column: 4/5;
  grid-row: 1/2;
  text-align: center;
}
.partHeader1-4 {
  grid-column: 5/6;
  grid-row: 1/2;
}
.partHeader1-5 {
  grid-column: 6/7;
  grid-row: 1/2;
}
  .burgerB {
    margin-left: 2rem;
  }
  .phoneInfo {
    margin-left: 3rem;
  }
  .langBox {
    margin-right: 20px;
    margin-top: 48px;
    margin-bottom: auto;
    margin-left: auto;
  }
  .lanmargin {
    margin-left: 4px;
  }
  ul.demo {
    list-style-type: none;
    margin: 0;
    padding: 0;
    text-align: left;
  }

  .nlang {
    height: 16px;

    top: calc(50% - 16px / 2);

    font-family: Inter;
    font-style: normal;
    font-weight: 400;
    font-size: 11px;
    line-height: 16px;
    /* identical to box height, or 133% */

    text-align: right;
    letter-spacing: 2px;
    text-transform: uppercase;

    /* metalix (ligtt,text) */

    color: #36454f;

    /* Inside Auto Layout */

    flex: none;
    order: 0;
    flex-grow: 0;
    margin: 0px 10px;
  }
  .navbar {
    background-color: #fbfbfb;
    padding: 0;
  }
  .navbarBrand {
    padding-top: 40px;
    padding-left: 10px;
    padding-bottom: 40px;
    padding-right: 10px;
  }
  .rec {
    position: absolute;
    visibility: hidden;
    width: 1px;
    height: 224px;
    left: 1112px;
    top: 0px;

    background: #b4c0cf;
  }
  .miniinfo {
    width: 240px;
    height: 16px;

    font-family: Inter;
    font-style: normal;
    font-weight: 300;
    font-size: 10px;
    line-height: 8px;
    /* identical to box height, or 160% */

    text-align: right;
    letter-spacing: 0.15em;
    text-transform: uppercase;

    color: #92a2ac;
  }
  .info {
    width: 240px;
    height: 16px;

    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 10px;
    line-height: 8px;
    /* identical to box height, or 133% */

    text-align: right;
    letter-spacing: 0.15em;
    text-transform: uppercase;

    /* metalix (ligtt,text) */

    color: #36454f;
  }
  .link {
    width: 240px;
    height: 24px;

    font-family: Inter;
    font-style: normal;
    font-weight: 400;
    font-size: 8px;
    line-height: 16px;
    /* identical to box height, or 200% */

    letter-spacing: 2px;
    text-transform: uppercase;

    /* metalix (ligtt,text) */

    color: #36454f;
  }
}
/****1440 */
@media (min-width: 1281px) and (max-width: 1440px) {
  /* Styles */
.partHeader {
  display: grid;
  grid-template-columns: 120px 1fr 1fr 1fr 1fr 1fr;
  grid-auto-rows: minmax(1136, auto);
  background: #fbfbfb;
}
.partHeader1-0 {
  grid-column: 1/2;
  grid-row: 1/2;
}
.partHeader1-1 {
  grid-column: 2/3;
  grid-row: 1/2;
}
.partHeader1-2 {
  grid-column: 3/5;
  grid-row: 1/2;
}
.partHeader1-3 {
  grid-column: 4/5;
  grid-row: 1/2;
  text-align: center;
}
.partHeader1-4 {
  grid-column: 5/6;
  grid-row: 1/2;
}
.partHeader1-5 {
  grid-column: 6/7;
  grid-row: 1/2;
}
  .burgerB {
    margin-left: 2rem;
  }
  .phoneInfo {
    margin-right: 20px !important;
    margin-left: 0;
  }
  .langBox {
    margin-right: 20px;
    margin-top: 48px ;
    margin-bottom: auto;
    margin-left: auto;
  }
  .lanmargin {
    margin-left: 4px;
  }
  ul.demo {
    list-style-type: none;
    margin: 0;
    padding: 0;
    text-align: left;
    margin-top: 48px;
 }

  .nlang {
    height: 16px;

    top: calc(50% - 16px / 2);

    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    /* identical to box height, or 133% */

    text-align: right;
    letter-spacing: 2px;
    text-transform: uppercase;

    /* metalix (ligtt,text) */

    color: #36454f;

    /* Inside Auto Layout */

    flex: none;
    order: 0;
    flex-grow: 0;
    margin: 0px 10px;
  }
  .navbar {
    background-color: #fbfbfb;
    padding: 0;
  }
  .navbarBrand {
    padding-top: 40px;
    padding-left: 10px;
    padding-bottom: 40px;
    padding-right: 10px;
  }
  .rec {
    position: absolute;
    visibility: hidden;
    width: 1px;
    height: 224px;
    left: 1112px;
    top: 0px;

    background: #b4c0cf;
  }
  .miniinfo {
    width: 290px;
    height: 16px;

    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 8px;
    /* identical to box height, or 160% */

    text-align: right;
    letter-spacing: 0.15em;
    text-transform: uppercase;

    color: #92a2ac;
  }
  .info {
    width: 290px;
    height: 16px;

    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 8px;
    /* identical to box height, or 133% */

    text-align: right;
    letter-spacing: 0.15em;
    text-transform: uppercase;

    /* metalix (ligtt,text) */

    color: #36454f;
  }
  .link {
    width: 240px;
    height: 24px;

    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    /* identical to box height, or 200% */

    letter-spacing: 2px;
    text-transform: uppercase;

    /* metalix (ligtt,text) */

    color: #36454f;
  }
  .bigMenu{
    width: 42vw;
  }
  .navbar-second-section{
    margin-left: -9rem;
  }
}
/* ----------- Non-Retina Screens ----------- */
@media screen 
  and (min-device-width: 1200px) 
  and (max-device-width: 1600px) 
  and (-webkit-min-device-pixel-ratio: 1) { 
     
     .phoneInfo{
       margin-left: 0px;
     }
     .link3{
       
       width: 328px;
       margin-top: 14px;
     }
}

/* ----------- Retina Screens ----------- */
@media screen 
  and (min-device-width: 1200px) 
  and (max-device-width: 1600px) 
  and (-webkit-min-device-pixel-ratio: 2)
  and (min-resolution: 192dpi) {
     .phoneInfo{
       margin-left: 0px;
     }
}
/* Large screens ----------- */
@media only screen and (min-width: 1824px) {
  /* Styles */
}

/* iPhone 4 ----------- */
@media only screen and (-webkit-min-device-pixel-ratio: 1.5),
  only screen and (min-device-pixel-ratio: 1.5) {
  /* Styles */
}
</style>